<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="!toggle.checked || viewType === 'table'"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip()"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <ng-container *ngIf="toggle.checked && viewType !== 'table'">
    <div class="row">
      <div class="col-md-12 mb-2">
        <mat-checkbox
          [formControl]="isDraftTaskCtrl"
          matTooltip="PM will review and approve the task created after incident creation"
          i18n-matTooltip
          >Review Task Before Creation</mat-checkbox
        >
      </div>
      <div class="col-md-6" *ngIf="filterByCategories">
        <mat-form-field2 class="mat-block" [showLabel]="false">
          <mat-label i18n>Select Categories</mat-label>
          <app-select
            [items]="categories"
            bindValue="value"
            bindLabel="label"
            [formControl]="form.get('categories')"
            [multiple]="true"
            [disabled]="isEditing$ | async"
            i18n-placeholder
            i18n-matTooltip
            placeholder="Apply to all categories"
            matTooltip="Select the categories you want to send the notification"
          >
          </app-select>
        </mat-form-field2>
      </div>
      <div class="col-md-6 d-flex gap-3">
        <button class="btn btn-secondary-info" (click)="info.onEditTask()" [disabled]="isEditing$ | async">
          <i class="cs-icon cs-icon-pencil"></i>
          <ng-container i18n>Edit Task</ng-container>
        </button>
        <button
          class="btn btn-secondary-danger"
          (click)="info.onDelete()"
          [disabled]="isEditing$ | async"
          *ngIf="deletable"
        >
          <i class="cs-icon cs-icon-trash"></i>
          <ng-container i18n>Delete</ng-container>
        </button>
      </div>
    </div>
  </ng-container>
</div>

<app-autopilot-automation-info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [task]="task"
  [hideTaskDateFields]="hideDateFields"
  (saveData)="onSaveData($event)"
  [class.d-none]="viewType !== 'table'"
  #info
></app-autopilot-automation-info>
